"use client"

import { useEffect, useState } from "react"
import tw from "tailwind-styled-components"
import { Formik, Form } from "formik"
import Loading from "../Loading"
import { InputGroup, FieldWrapper, Label, SubmitBtn } from "../Styles/InputStyles"
import MenuItem from "@mui/material/MenuItem"
import Select from "@mui/material/Select"
import Model from "../Model"
import { toast } from "react-toastify"
import DropzoneImageUpload from "../Properties/DropzoneImageUpload"
import DropZone from "../Properties/Dropzone"

const UploadRentAgreement = ({
  rentUploadMutate,
  documentUploadLoading,
  setRentAgreement,
  selectedData,
}) => {
  const [createRentAgreement, setCreateRentAgreement] = useState(
    String(selectedData?.isRentAgreementEnabled) === "1" ? "1" : "0"
  )

  const [showUploadRentAgreement, setShowUploadRentAgreement] = useState(
    String(selectedData?.isRentAgreementEnabled) === "1"
  )

  useEffect(() => {
    if (selectedData?.rentAgreementPath) {
      setCreateRentAgreement("1")
      setShowUploadRentAgreement(true)
    }
  }, [selectedData?.rentAgreementPath])

  const initialValues = {
    id: selectedData?.id || "",
    clientId: selectedData?.clientId || "",
  }

  const handleSelectUserAgreement = (value) => {
    setCreateRentAgreement(value)
    setShowUploadRentAgreement(value === "1")
  }

  const SubmitHandler = (values) => {
    if (createRentAgreement === "1") {
      if (!values.rentAgreement && !selectedData?.rentAgreementPath) {
        toast.error("Please upload the Rent Agreement.")
        return
      }
      if (!values.ownerSignatureImage && !selectedData?.signaturePath) {
        toast.error("Please upload the Owner Signature.")
        return
      }
    }

    rentUploadMutate({
      ...values,
      createRentAgreement,
      id: values.id,
      clientId: values.clientId,
    })
  }

  const name = (name) => {
    if (!name) return ""
    const lowerCaseName = name.trim().toLowerCase()
    return lowerCaseName.length > 10
      ? `${lowerCaseName.slice(0, 10)}...`
      : lowerCaseName
  }

  return (
    <Model width="w-11/12 max-w-lg" setOpenModel={setRentAgreement}>
      <Title>Rent Agreement</Title>

      {documentUploadLoading && <Loading />}

      {!documentUploadLoading && (
        <Formik
          initialValues={initialValues}
          onSubmit={SubmitHandler}
          enableReinitialize
        >
          {({ values }) => (
            <Form>
              <Wrapper>
                <InputGroup>
                  <Label htmlFor="createRentAgreement">
                    Create Rent Agreement
                  </Label>
                  <FieldWrapper $select={true}>
                    <Select
                      value={createRentAgreement}
                      onChange={(e) =>
                        handleSelectUserAgreement(e.target.value)
                      }
                      className="w-full pl-2"
                      style={{ height: "40px" }}
                    >
                      <MenuItem value="1">Yes</MenuItem>
                      <MenuItem value="0">No</MenuItem>
                    </Select>
                  </FieldWrapper>
                </InputGroup>

                {showUploadRentAgreement && (
                  <InputGroup>
                    <Label htmlFor="rentAgreement">
                      Upload Rent Agreement
                    </Label>
                    <DropZone
                      setUploadFile={(file) =>
                        (values.rentAgreement = file)
                      }
                      componentFor="rentAgreement"
                    />
                  </InputGroup>
                )}

                {selectedData?.path && (
                  <InputGroup>
                    <a
                      href={selectedData.path}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="underline text-primary-color text-sm"
                    >
                      {name(selectedData?.name)}/rentagreement.pdf
                    </a>
                  </InputGroup>
                )}

                <InputGroup>
                  <Label htmlFor="ownerSignature">
                    Upload Owner Signature
                  </Label>
                  <DropzoneImageUpload
                    setUploadFile={(file) =>
                      (values.ownerSignatureImage = file)
                    }
                    componentFor="signature"
                  />
                </InputGroup>

                {selectedData?.signaturePath && (
                  <InputGroup>
                    <a
                      href={selectedData.signaturePath}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="underline text-primary-color text-sm"
                    >
                      {name(selectedData?.name)}/signature.png
                    </a>
                  </InputGroup>
                )}
              </Wrapper>

              <BtnWrapper>
                <SubmitBtn type="submit">Upload</SubmitBtn>
              </BtnWrapper>
            </Form>
          )}
        </Formik>
      )}
    </Model>
  )
}

const Wrapper = tw.div`grid gap-6 my-6 px-1`
const Title = tw.h2`text-lg md:text-xl lg:text-2xl text-gray-600 font-medium mb-6 text-center`
const BtnWrapper = tw.div`w-full flex items-center justify-center space-x-10 mt-8`

export default UploadRentAgreement
